import React from 'react'

export default class OutState extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(e) {
    this.props.onChangeCallback(e.target.checked)
  }

  render() {

    let retn = this.props.retn

    let inputValue = typeof retn.is_igst !== "undefined" ? retn.is_igst : false

    let check = <div> <input type="checkbox" checked={inputValue} onChange={this.handleChange} /></div>

    return <div>{check}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/credit/rowelements/outstate.js